// ================= CONFIG =================
const FREEBIE_CONFIG = {
  minCart: 899,
  products: {
    paid: {
      faceWash: 46526288199865,   
      faceScrub: 46526359503033,
      shampoo: 46695637221561,
      hairSerum: 47114042310841
    },
    free: {
      faceWash: 47058807161017,   
      faceScrub: 47058821873849,
      shampoo: 47058816041145
    }
  }
};


const COMBO_DISCOUNT_CODE = "COMBO10";
let isUpdatingFreebie = false;

// ================= HELPER =================
function determineFreeProduct(hasFaceWash, hasFaceScrub, hasShampoo,hasHairSerum, free) {
  if (hasShampoo && hasHairSerum) return free.faceWash;
  if (!hasFaceWash && !hasFaceScrub && !hasShampoo) return free.faceWash;
  if (hasFaceWash && !hasFaceScrub && !hasShampoo) return free.faceScrub;
  if (hasFaceScrub && !hasFaceWash && !hasShampoo) return free.faceWash;
  if (hasShampoo && !hasFaceWash && !hasFaceScrub) return free.faceWash;
  if (hasFaceWash && hasFaceScrub && !hasShampoo) return free.shampoo;
  if (hasFaceScrub && hasShampoo && !hasFaceWash) return free.faceWash;
  if (hasFaceWash && hasShampoo && !hasFaceScrub) return free.faceScrub;
  if (hasFaceWash && hasFaceScrub && hasShampoo) return free.faceWash;
  return null;
}
// ================= COMBO 10% DISCOUNT SYNC =================
function syncComboDiscount(cart, hasShampoo, hasHairSerum) {
  const alreadyApplied = (cart.cart_level_discount_applications || []).some(
    (d) => d.title === COMBO_DISCOUNT_CODE
  );

  const shouldApply = hasShampoo && hasHairSerum;

  if (shouldApply && !alreadyApplied) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: COMBO_DISCOUNT_CODE })
    }).catch(() => {});
  }

  if (!shouldApply && alreadyApplied) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: "" })
    }).catch(() => {});
  }

  return Promise.resolve();
}
function handleFreebie(cart = null) {

  if (isUpdatingFreebie) return Promise.resolve();
  isUpdatingFreebie = true;

  return new Promise((resolve) => {

    const done = () => {
      isUpdatingFreebie = false;
      resolve();
    };

    const processCart = (cart) => {

      const freebieIds = [
        FREEBIE_CONFIG.products.free.faceWash,
        FREEBIE_CONFIG.products.free.faceScrub,
        FREEBIE_CONFIG.products.free.shampoo
      ];

      const paid = FREEBIE_CONFIG.products.paid;
      const free = FREEBIE_CONFIG.products.free;

      // ===== CALCULATE PAID TOTAL =====
      let total = cart.items
        .filter(item => !freebieIds.includes(item.id))
        .reduce((sum, item) => sum + item.original_line_price, 0) / 100;

      // ===== CORRECT FREEBIE =====
      let hasFaceWash = false, hasFaceScrub = false, hasShampoo = false, hasHairSerum = false;
      cart.items.forEach(item => {
        if (item.id == paid.faceWash) hasFaceWash = true;
        if (item.id == paid.faceScrub) hasFaceScrub = true;
        if (item.id == paid.shampoo) hasShampoo = true;
        if (item.id == paid.hairSerum) hasHairSerum = true;
      });
  // ===== SYNC COMBO 10% DISCOUNT (independent of freebie flow) =====
      syncComboDiscount(cart, hasShampoo, hasHairSerum);
      const freeProduct = determineFreeProduct(hasFaceWash, hasFaceScrub, hasShampoo, hasHairSerum, free);
      const currentFreebie = cart.items.find(item =>
        freebieIds.includes(item.id) &&
        item.properties &&
        (item.properties._freebie === true || item.properties._freebie === 'true')
      );

      if (
        total >= FREEBIE_CONFIG.minCart &&
        currentFreebie &&
        currentFreebie.id == freeProduct &&
        currentFreebie.quantity === 1
      ) {
        done();
        return;
      }
      const seen = {};
      let mergeUpdates = {};
      cart.items.forEach(item => {
        if (!freebieIds.includes(item.id)) {
          if (seen[item.id] !== undefined) {
            mergeUpdates[seen[item.id].key] = seen[item.id].quantity + item.quantity;
            mergeUpdates[item.key] = 0;
          } else {
            seen[item.id] = item;
          }
        }
      });

      if (Object.keys(mergeUpdates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: mergeUpdates })
        }).finally(done);
        return;
      }

      // ===== REMOVE UNAUTHORIZED FREEBIES =====
      let updates = {};
      cart.items.forEach(item => {
        const isFreebieProduct = freebieIds.includes(item.id);
        const isAuthorizedFreebie =
          item.properties &&
          (item.properties._freebie === true || item.properties._freebie === "true");

        if (isFreebieProduct && !isAuthorizedFreebie) {
          updates[item.key] = 0;
        }
        if (isFreebieProduct && isAuthorizedFreebie && item.quantity > 1) {
          updates[item.key] = 1;
        }
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).finally(done);
        return;
      }

      // ===== MIN — REMOVE =====
      if (total < FREEBIE_CONFIG.minCart) {
        removeFreebies(cart, done);
        return;
      }

      // =====APPLY FREEBIE =====
      if (freeProduct) {
        applyFreebie(cart, freeProduct, done);
      } else {
        done();
      }
    };

    if (cart) {
      processCart(cart);
    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(processCart);
    }

  });
}

// ================= APPLY FREEBIE =================
function applyFreebie(cart, freeProduct, done) {

  let hasCorrect = cart.items.some(item =>
    item.id == freeProduct &&
    item.properties &&
    (item.properties._freebie === true || item.properties._freebie === "true")
  );

  let updates = {};
  cart.items.forEach(item => {
    if (
      item.properties &&
      (item.properties._freebie === true || item.properties._freebie === "true")
    ) {
      if (item.id != freeProduct) {
        updates[item.key] = 0;
      }
    }
  });

  if (Object.keys(updates).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: freeProduct,
          quantity: 1,
          properties: { _freebie: true }
        })
      });
    })
    .finally(done);
    return;
  }

  if (!hasCorrect) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: freeProduct,
        quantity: 1,
        properties: { _freebie: true }
      })
    })
    .then(() => {
      if (typeof showToast === "function") {
        showToast("🎁 You unlocked a FREE gift!");
      }
    })
    .finally(done);
    return;
  }

  done();
}

// ================= REMOVE FREEBIES =================
function removeFreebies(cart, done) {

  let updates = {};
  cart.items.forEach(item => {
    if (
      item.properties &&
      (item.properties._freebie === true || item.properties._freebie === "true")
    ) {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).finally(done);
  } else {
    done();
  }
}

// ================= INIT =================
document.addEventListener("DOMContentLoaded", function () {
  handleFreebie();
});

if (window.location.pathname === '/cart') {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const freebieIds = [
        47058807161017,
        47058821873849,
        47058816041145
      ];
      let updates = {};
      cart.items.forEach(item => {
        if (freebieIds.includes(item.id)) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => handleFreebie());
      }
    });
}